import { useEffect, useState } from "react";
import { loadStripe } from "@stripe/stripe-js";
import { FLOWS_ENUM } from "../../../common/enums";
import apiAccess from "../../../api/apiAccess";

export function useDeckardStripe(flow) {
    const [stripe, setStripe] = useState(null);
    const isTotFlow = flow === FLOWS_ENUM.PAY_TOT;
  
    useEffect(() => {
      (async () => { 
        const data  = await apiAccess.getStripePublicKey();
        const totKey = data?.tot?.stripePublishableKey
        const stripePublishableKey = (isTotFlow && totKey)
          ? totKey
          : data?.stripePublishableKey;
        const stripe = await loadStripe(stripePublishableKey)
        setStripe(stripe);
      })()
    }, [isTotFlow]); 
  
    return stripe;
  }
